import gql from 'graphql-tag';

const QUERY_NEARBY_CITIES = gql`
  query NearbyCities($bbox: BboxInput!, $limit: Int, $maxDistanceKm: Int) {
    nearbyCities(bbox: $bbox, limit: $limit, maxDistanceKm: $maxDistanceKm) {
      cityId
      distanceKm
    }
  }
`;

export const getNearbyCitiesQuery =
  client =>
  ({ bbox, limit = 3, maxDistanceKm = 100 }) =>
    client.query({
      query: QUERY_NEARBY_CITIES,
      fetchPolicy: 'cache-first',
      variables: { bbox, limit, maxDistanceKm }
    });
